import { useEffect, useState } from "react";
import { Routes, Route as Link } from "react-router-dom"

import { Header, Home, Events, EventsList, Team, Contact, Footer, PageNotFound, Socials, GoToTop } from './components';

import scrollToTop from "./utility/scrollToTop";

// importing all events
import { EventsTemplate, TechnoGrad23 } from './components/Events/events-components'

import eventsDetails, { eventIndexConstants } from './utility/event-details'

const App = () => {
    const [onPage, setOnPage] = useState(1);
    const [notTop, setNotTop] = useState({ header: false, toTopButton: false });

    useEffect(() => {
        function showHideToTopButton() {
            if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
                setNotTop({ ...notTop, header: true });

                if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
                    setNotTop({ header: true, toTopButton: true });
                }
            } else {
                setNotTop({ header: false, toTopButton: false });
            }
        }

        window.addEventListener('scroll', showHideToTopButton);

        return () => {
            window.removeEventListener('scroll', showHideToTopButton);
        };
    }, [notTop])

    useEffect(() => {
        scrollToTop();
    }, [onPage])

    return (
        <>
            <Header onPage={onPage} setOnPage={setOnPage} notTop={notTop.header} />

            <Routes>
                <Link path='/' element={<Home setOnPage={setOnPage} />} />

                <Link exact path='events' element={<Events setOnPage={setOnPage} />}>
                    <Link index element={<EventsList />} />

                    {/* All events routes */}
                    {
                        // All the events that use the EventsTemplate
                        eventsDetails.map((eventDetail, key) => {
                            if(eventDetail.followsTemplate) {
                                return <Link path={eventDetail.url}>
                                    <Link index element = {<EventsTemplate event_idx={key} />} />
                                </Link>
                            }
                        })
                    }

                    <Link path="technograd-23">
                        <Link index element={<TechnoGrad23 event_idx={eventIndexConstants.TECHNOGRAD23}/>} />
                    </Link>
                </Link>

                <Link exact path='team' element={<Team setOnPage={setOnPage} />} />

                <Link exact path='contact' element={<Contact setOnPage={setOnPage} />} />

                <Link path="*" element={<PageNotFound />} />
            </Routes>

            <GoToTop notTop={notTop.toTopButton} />
            <Socials />

            <Footer onPage={onPage} setOnPage={setOnPage} />
        </>
    )
}

export default App